import React, { useState, useEffect } from "react";
import "./index.scss";
import { Modal } from "react-bootstrap";
import ReactPlayer from "react-player";
import AOS from "aos";

export const MBDClassic = () => {
  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);

  useEffect(() => {
    AOS.init({ duration: 2000, mirror: true });
  }, []);

  return (
    <div className="MBDClassic">
      <div className="component">
        <div
          className="inner-wrap"
          data-aos="zoom-in-up"
          data-aos-offset="-200"
          data-aos-duration="600"
        >
          <div className="textWrap">
            <h2>
              Client <span>Spotlight</span>
            </h2>
            <h6>From feeling stuck to finding support that works.</h6>
          </div>
          <div className="playButton" onClick={handleShowModal}>
            <svg viewBox="0 0 1000 1000" xmlns="http://www.w3.org/2000/svg">
              <circle cx="500" cy="500" r="500" fill="#fff" />
              <polygon points="387.12 751.38 698.72 500 387.12 248.63" />
            </svg>
          </div>
        </div>
      </div>

      <MbdModal show={showModal} onHide={handleCloseModal} />
    </div>
  );
};

const MbdModal = ({ show, onHide }) => (
  <Modal show={show} onHide={onHide} dialogClassName="mbd-modal">
    {/* simple close “×” in top-right */}
    <div className="modal-close" onClick={onHide}>×</div>

    <Modal.Body className="p-0">
      <ReactPlayer
        url="https://youtu.be/gEjNV8_xxhQ"
        playing
        controls
        width="100%"
        height="100%"
        className="react-player"
      />
    </Modal.Body>
  </Modal>
);
